exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nfooter .right[data-v-e39b7f38] {\n  text-align: right;\n  clear: both;\n  float: right;\n}\nfooter small[data-v-e39b7f38] {\n  clear: both;\n  color: #ccc;\n}\nfooter footer > div > small[data-v-e39b7f38]::nth-child(2) {\n  color: #aaa !important;\n}\n", ""]);

// exports
